var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import GraphLine from '../../components/ins-claim/graph-line.vue';
import GraphLine2 from '../../components/ins-claim/graph-line2.vue';
import GraphHistogram from '../../components/ins-claim/graph-histogram.vue';
import IndicatorOverview from '../../components/ins-claim/claim-indicators.vue';
import { transChartLine2, formatHistogramData, transChartLineData, formDefaultSearchDate, formatRMB, } from './trans-data-util';
import * as CLAIM_API from './claim-api';
import { chartLine, chartLine2, chartHistogram } from './chart-config';
import * as TIPS from './const-tips';
export default Vue.extend({
    components: {
        'chart-line': GraphLine,
        'chart-line2': GraphLine2,
        'chart-histogram': GraphHistogram,
        'el-indicator-overview': IndicatorOverview,
    },
    data: function () {
        return {
            searchParam: null,
            searchDefaultParam: {},
            loading: true,
            activeTab: 'tab-case',
            tipsGraph: TIPS.TipHomeClaimTrend,
            indicators: [
                {
                    span: 4,
                    label: '总出险次数',
                    value: '--',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeTotalClaim,
                },
                {
                    span: 4,
                    label: '满期出险率',
                    value: '--%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredClamRate,
                },
                {
                    span: 4,
                    label: '总赔款金额',
                    value: '--',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeTotalPaid,
                    color: '#876AD6',
                },
                {
                    span: 4,
                    label: '满期赔付率',
                    value: '--%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredPaidRate,
                },
                {
                    span: 4,
                    label: '万元以下赔付时效',
                    value: '--',
                    type: 'bar',
                    custFont: true,
                    tips: TIPS.TipHomeEfficiency,
                },
            ],
            insCaseOptions: chartLine,
            insCaseSum: '',
            insCaseAverage: '',
            payExpiredTop: '',
            payExpiredLow: '',
            payExpiredAver: '',
            paymentOptions: chartLine2,
            payExpiredOptions: __assign({}, chartLine),
            payEfficiencyOptions: chartHistogram,
        };
    },
    methods: {
        formParams: function () {
            return this.searchParam;
        },
        setParams: function (params) {
            this.searchParam = params;
        },
        initParams: function () {
            this.setParams(formDefaultSearchDate());
            this.initIndicatorDefault();
        },
        initIndicatorDefault: function () {
            this.searchDefaultParam = this.formParams();
        },
        handleSearch: function (params) {
            this.setParams(params);
            this.onFreshPage();
        },
        handleTab: function (tab, event) {
            this.activeTab = tab.name;
            this.freshTabPage();
        },
        freshTabPage: function () {
            var params = this.formParams();
            if (this.activeTab === 'tab-case') {
                this.tipsGraph = TIPS.TipHomeClaimTrend;
                this.loadInsCaseTrend(params);
            }
            else if (this.activeTab === 'tab-payment') {
                this.tipsGraph = TIPS.TipHomePaidTrend;
                this.loadInsPaymentTrend(params);
            }
            else if (this.activeTab === 'tab-expired') {
                this.tipsGraph = TIPS.TipHomeExpiredTrend;
                this.loadInsExpiredTrend(params);
            }
            else if (this.activeTab === 'tab-efficiency') {
                this.tipsGraph = TIPS.TipHomeEfficiencyTrend;
                this.loadInsEfficentTrend(params);
            }
        },
        showCaseDetail: function () {
            this.$router.push({
                name: 'boardCase',
                params: { searchParam: this.formParams() },
            });
        },
        showPaidDetail: function () {
            this.$router.push({
                name: 'boardPayment',
                params: { searchParam: this.formParams() },
            });
        },
        showPaydoneDetail: function () {
            this.$router.push({
                name: 'boardPayExpired',
                params: { searchParam: this.formParams() },
            });
        },
        showPayEfficiencyDetail: function () {
            this.$router.push({
                name: 'boardTimeEfficiency',
                params: { searchParam: this.formParams() },
            });
        },
        // 刷新整个页面
        onFreshPage: function () {
            var params = this.formParams();
            var ovParams = __assign({}, params, { overviewType: CLAIM_API.OVER_VIEW_ALL });
            this.loadOverview(ovParams);
            // this.loadInsCaseTrend(params)
            this.freshTabPage();
        },
        loadOverview: function (params) {
            var _this = this;
            CLAIM_API.queryClaimOverview(params).then(function (res) {
                if (!res || !res.data || !res.data.totalOverview)
                    return;
                if (res.errorCode)
                    return;
                var _a = res.data.totalOverview, totalCaseCount = _a.totalCaseCount, expireCaseRate = _a.expireCaseRate, totalPayAmount = _a.totalPayAmount, expirePayRate = _a.expirePayRate, claimAgingDisplay = _a.claimAgingDisplay;
                _this.indicators[0].value = totalCaseCount.toString();
                _this.indicators[1].value = expireCaseRate.toString() + '%';
                _this.indicators[2].value = formatRMB(totalPayAmount);
                _this.indicators[3].value = expirePayRate.toString() + '%';
                _this.indicators[4].value = claimAgingDisplay;
            });
        },
        loadInsCaseTrend: function (params) {
            var _this = this;
            CLAIM_API.queryCaseTrend(params).then(function (res) {
                if (!res || !res.data)
                    return;
                if (res.errorCode)
                    return;
                _this.insCaseSum = res.data.totalCaseCount;
                _this.insCaseAverage = res.data.average;
                _this.insCaseOptions.data = transChartLineData(res.data.riskTrendList, 'caseCount');
            });
        },
        loadInsPaymentTrend: function (params) {
            var _this = this;
            CLAIM_API.queryPaymentTrend(params).then(function (res) {
                if (!res || !res.data || !res.data.claimTrendList)
                    return;
                if (res.errorCode)
                    return;
                var dataset = _this.formatChart2Data(res.data.claimTrendList);
                _this.paymentOptions.data = transChartLine2(dataset);
            });
        },
        loadInsExpiredTrend: function (params) {
            var _this = this;
            CLAIM_API.queryExpiredTrend(params).then(function (res) {
                if (!res || !res.data || !res.data.expireTrendList)
                    return;
                if (res.errorCode)
                    return;
                _this.payExpiredTop = res.data.maxExpirePayoutRatio.toString() + '%';
                _this.payExpiredLow = res.data.minExpirePayoutRatio.toString() + '%';
                _this.payExpiredAver = res.data.avgExpirePayoutRatio.toString() + '%';
                var rawData = res.data.expireTrendList;
                var ds = rawData.map(function (item) {
                    item.expirePayoutRatio = Number(Number(item.expirePayoutRatio).toFixed(2));
                    return item;
                });
                _this.payExpiredOptions.data = transChartLineData(ds, 'expirePayoutRatio');
            });
        },
        loadInsEfficentTrend: function (params) {
            var _this = this;
            CLAIM_API.queryCaseEfficiencyTrend(params).then(function (res) {
                if (!res || !res.data || !res.data.claimAgingTrendList)
                    return;
                if (res.errorCode)
                    return;
                _this.payEfficiencyOptions.data = formatHistogramData(res.data.claimAgingTrendList);
            });
        },
        formatChart2Data: function (rawData) {
            var dataList = [];
            rawData.forEach(function (item) {
                dataList.push({
                    xAxis: moment(item.date).format('YYYY/MM/DD'),
                    paid: item.claimAmount.payed,
                    unpaid: item.claimAmount.unPayed,
                });
            });
            return dataList;
        },
    },
    mounted: function () {
        this.initParams();
        this.$store.dispatch('vinsurance/GET_INS_COMPANYS'); // 获取保险公司选项
        this.$store.dispatch('vinsurance/GET_RENT_COMPANYS'); // 获取保险公司选项
        this.activeTab = 'tab-case';
        this.payExpiredOptions.scale = [
            {
                dataKey: 'xAxis',
                alias: '日期',
            },
            {
                dataKey: 'yAxis',
                alias: '赔付率',
                formatter: function (value) { return value + '%'; },
            },
        ];
        this.onFreshPage();
    },
});
